import React from 'react';
import {MasterLayout} from 'components/layouts';
import MemberZone from './MemberZone.jsx';
import title from 'constants/TitlePages.js';
import {UserLayout} from 'components/layouts/user';
import {MyDemandDetailContent} from 'components/users/my-demand-content';
import {Demands} from 'api';

class MyDemandDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  componentDidMount() {
    document.title = title.MyDemandDetailPage;

    Demands.actions.demand.request({
      id: this.props.match.params.id,
      filter: {
        include: ['user', 'categories']
      }
    }).then(response => {
      this.setState({
        demand: response.data
      });
    });
  }

  render() {
    return (
      <MasterLayout>
        <UserLayout active="my-posted-demands">
          {this.state.demand &&
            <MyDemandDetailContent {...this.state.demand}/>
          }
        </UserLayout>
      </MasterLayout>
    );
  }
}

export default MemberZone(MyDemandDetailPage);



// WEBPACK FOOTER //
// ./pages/users/MyDemandDetailPage.jsx